import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";

export const Styles = createGlobalStyle`
    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    body,
    html,
    a {
        font-family: ${theme.fonts.body};
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: ${theme.colors.background};
        overflow-x: hidden;
        color: ${theme.colors.text};
        -webkit-font-smoothing: antialiased;
    }

    a:hover {
        color: ${theme.colors.brown};
    }

    input,
    textarea {
        border-radius: ${theme.radius.sm};
        border: 0;
        background: ${theme.colors.tan};
        transition: all 0.3s ease-in-out;
        outline: none;
        width: 100%;
        padding: 1rem 1.25rem;

        :focus-within {
            background: ${theme.colors.white};
            box-shadow: ${theme.colors.brown} 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: ${theme.fonts.heading};
        color: ${theme.colors.brown};
        font-weight: 600;
        line-height: 1.2;
        margin: 0;
    }

    h1 {
        font-size: clamp(2.25rem, 5vw, 3.5rem);
    }

    h2 {
        font-size: clamp(1.75rem, 3.5vw, 2.75rem);
    }

    h3 {
        font-size: clamp(1.25rem, 2.5vw, 1.75rem);
    }

    ul {
        color: ${theme.colors.text};
        font-size: 16px;
        line-height: 1.6;
    }

    p {
        color: ${theme.colors.text};
        font-size: 16px;
        line-height: 1.7;
        margin: 0;
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${theme.colors.brown};
    }

    .skip-link {
        position: absolute;
        top: -100px;
        left: 1rem;
        z-index: 1000;
        padding: 0.75rem 1.25rem;
        background: ${theme.colors.brown};
        color: ${theme.colors.white};
        border-radius: ${theme.radius.sm};
        font-weight: 600;
        font-size: 0.875rem;
        transition: top 0.2s ease;
    }

    .skip-link:focus {
        top: 1rem;
        outline: 2px solid ${theme.colors.accent};
        outline-offset: 2px;
    }

    button:focus-visible,
    a:focus-visible,
    [role="button"]:focus-visible {
        outline: 2px solid ${theme.colors.accent};
        outline-offset: 2px;
    }
    
    *:focus:not(:focus-visible) {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
        background: ${theme.colors.background};
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
